import { useParams } from 'react-router-dom';
import ScreenForm from './components/ScreenForm';

const ScreenDetailPage = () => {
  const { id } = useParams();

  return <ScreenForm screenId={id} />;
};

export default ScreenDetailPage;

